/**
 * DownloadsRedirect — Phase 1.7 polish
 * When the SPA is served at `/downloads` or `/downloads/` (which happens on
 * the production deployment, whose static server doesn't auto-resolve a
 * directory request to its index.html), bounce immediately to the static
 * `/downloads/index.html` file. On preview, the static file is served
 * directly and React never runs here, so this is a no-op there.
 */
import { useEffect } from 'react';

export default function DownloadsRedirect() {
  useEffect(() => {
    window.location.replace('/downloads/index.html');
  }, []);
  return (
    <div style={{ padding: '48px', fontFamily: 'system-ui', color: '#555' }}>
      Loading downloads…
    </div>
  );
}
